/**
 * Updates the hash without causing a full page reload. Returns the href.
 *
 * @param hash The hash to set.
 * @returns The current href.
 */
export const updateHash = (hash: string): Nullable<string> => {
    /* eslint-disable-next-line no-restricted-syntax
       --
       This is a permitted used of `window.location` access in our codebase.
       We need to be able to access the hash and href here.
     */
    const location = typeof window !== "undefined" ? window.location : null;
    if (!location) {
        return undefined;
    }
    location.hash = hash;
    return location.href;
};
